'use strict';

var StepSponsorshipDirective = function StepSponsorshipDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/step-sponsorship.html'),
    controller: 'StepSponsorshipController',
    link: function link(scope) {
      scope.$on('scheduleChange:stepEntered', scope.stepEntered);
    }
  };
};
StepSponsorshipDirective.$inject = [];
module.exports = StepSponsorshipDirective;